<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LntadM/tc-custom/9780253029157.jpg?1713386459995" alt="This image is the cover for the book Chicago Union Station, Railroads Past and Present"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Chicago Union Station, Railroads Past and Present
      </h1>
      <p class="bookDescription body article font2">
        <b>A history of the Midwestern transportation hub and its impact on the city and the region, plus stunning photographs of the station’s architecture.</b><br/><br/>More than a century before airlines placed it at the center of their systems, Chicago was already the nation’s transportation hub—from Union Station, passengers could reach major cities on the Atlantic, Pacific and Gulf coasts as well as countless points in between.<br/><br/>Chicago’s history is tightly linked to its railroads. Railroad historian Fred Ash begins in the mid-1800s, when Chicago dominated Midwest trade and was referred to as the “Railroad Capital of the World.” During this period, swings in the political climate significantly modified the relationship between the local government and its largest landholders, the railroads. From here, Ash highlights competition at the turn of the twentieth century between railroad companies that greatly influenced Chicago’s urban landscape. Profiling the fascinating stories of businessmen, politicians, workers, and immigrants whose everyday lives were affected by the bustling transportation hub, Ash documents the impact Union Station had on the growing city and the entire Midwest.<br/><br/>Featuring more than one hundred photographs of the famous beaux art architecture, <i>Chicago Union Station</i> is a beautifully illustrated tribute to one of America’s overlooked treasures.<br/><br/><b>“The book includes more than 100 illustrations, a quarter of which are in color—but the real value is in author Ash’s narrative; he’s devoted decades to the study of terminals in the Railroad Capital, and it shows in this marvelous work.” —Classic Trains</b><br/><br/><b>“The station’s history is thoughtfully revealed alongside concurrent economic and political events unfolding in Chicago at given points in time, thus providing the reader with a deeper understanding of why certain station milestones occurred when they did and the way they did.” —The Michigan Railfan</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Fred Ash
      </h2>
      
      <p class="authorDescription body article"><P>Fred Ash's interest in railroads, especially passenger trains, was piqued as a teenager and nurtured after moving to Chicago. After thirty years specializing in nonprofit and government finance, he retired to complete this history that has lain in wait for over twenty years.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?093cefd5